import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';
import type { Category } from '../types';

let cached: Category[] | null = null;

export function useCategories() {
  const [categories, setCategories] = useState<Category[]>(cached ?? []);
  const [loading, setLoading] = useState(!cached);

  useEffect(() => {
    if (cached) return;
    void supabase
      .from('categories')
      .select('*')
      .eq('active', true)
      .order('sort_order')
      .then(({ data }) => {
        const cats = (data ?? []) as Category[];
        cached = cats;
        setCategories(cats);
        setLoading(false);
      });
  }, []);

  function invalidate() {
    cached = null;
    void supabase
      .from('categories')
      .select('*')
      .eq('active', true)
      .order('sort_order')
      .then(({ data }) => {
        const cats = (data ?? []) as Category[];
        cached = cats;
        setCategories(cats);
      });
  }

  return { categories, loading, invalidate };
}
